import { isFlagOn, SUBNAV_BREADCRUMBS_FLAG } from 'utils/featureFlags'

/**
 * Maps a sanitized CMS breadcrumb entry to ordered crumb data.
 * Curriculum-service turns `routeCollection` into `route`.
 * A title with no url is the current page: it still renders, but not as a link.
 * @param {Object} breadcrumb
 * @param {Array} [breadcrumb.route]
 * @returns {Array<{displayTitle: string, url?: string}>}
 */
export const getBreadcrumbLinks = breadcrumb => {
  const routes = Array.isArray(breadcrumb?.route) ? breadcrumb.route : []

  return routes.reduce((links, route) => {
    const displayTitle =
      typeof route?.displayTitle === 'string' ? route.displayTitle.trim() : ''
    const url = typeof route?.url === 'string' ? route.url.trim() : ''

    if (!displayTitle) {
      return links
    }

    return [
      ...links,
      url
        ? {
            displayTitle,
            url,
          }
        : { displayTitle },
    ]
  }, [])
}

/**
 * Whether the CMS breadcrumb will render, so pages with a legacy back link
 * can swap it out only when there is a breadcrumb to show instead.
 * @param {Object} breadcrumb
 * @returns {boolean}
 */
export const hasBreadcrumbLinks = breadcrumb =>
  isFlagOn([SUBNAV_BREADCRUMBS_FLAG]) &&
  getBreadcrumbLinks(breadcrumb).length > 0
